export default "/_next/static/fonts/SmileScript-5bc3a4194d38e74d52db7df5c232c76e.woff2";